import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import { useCopyToClipboard } from '@cryptosheets/hooks';
import { Drawer, Empty, message, Typography, Result } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import OutputMenu from './Menu';
import JSONEditor from '../../../json-editor';
import { OutputWrapper, OutputMenuWrapper } from './index.style';
var {
  Text
} = Typography;

function pathTojq(path, copyToClipboard) {
  // // WITH QUOTES
  // let pathString = '';
  // path.forEach(function (segment, index) {
  //   // path is an array, loop through it
  //   if (typeof segment === 'number') {
  //     // format the selector for array indexs ...
  //     pathString += `[${segment}]`;
  //   } else {
  //     // ... or object keys
  //     pathString += `."${segment}"`;
  //   }
  // });
  // NO QUOTES
  var pathString = '';
  path.forEach(function (segment, index) {
    // path is an array, loop through it
    if (typeof segment === 'number') {
      // format the selector for array indexs ...
      pathString += "[".concat(segment, "]");
    } else {
      // ... or object keys
      pathString += ".".concat(segment);
    }
  });

  if (_.startsWith(pathString, '.')) {
    pathString = "@".concat(pathString);
  }

  message.info({
    key: 'copy-to-clipboard',
    content: "Copied ".concat(pathString)
  }); // show it to the user.

  return copyToClipboard(pathString);
}

function _onEvent(node, event, copyToClipboard) {
  if (event.type === 'click') {
    var {
      path
    } = node;
    return pathTojq(path, copyToClipboard);
  }
}

function generateContent(_ref) {
  var {
    loading,
    data,
    json,
    clickedPath,
    jsonEditorOptions,
    mode,
    setMode
  } = _ref;

  if (loading) {
    return /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignContent: 'center'
      }
    }), /*#__PURE__*/React.createElement(Result, {
      icon: /*#__PURE__*/React.createElement(LoadingOutlined, null),
      title: "Hang Tight, we are fetching your data...",
      extra: /*#__PURE__*/React.createElement(Text, null, "This should only take a few moments...")
    })));
  }

  if (!data) {
    return /*#__PURE__*/React.createElement(Empty, {
      image: Empty.PRESENTED_IMAGE_SIMPLE,
      description: "No data. Hit \"Make Request\" to see output of endpoint."
    });
  }

  return /*#__PURE__*/React.createElement(OutputWrapper, null, /*#__PURE__*/React.createElement(OutputMenuWrapper, null, /*#__PURE__*/React.createElement(OutputMenu, {
    json: json,
    clickedPath: clickedPath,
    mode: mode,
    setMode: setMode
  })), /*#__PURE__*/React.createElement(JSONEditor, jsonEditorOptions));
}

export default function Output(_ref2) {
  var {
    data,
    loading = false,
    closeDrawer,
    drawerVisible,
    screenWidth
  } = _ref2;
  // const [text, setText] = useState(JSON.stringify(data));
  var [json, setJson] = useState(data);
  var [state, copyToClipboard] = useCopyToClipboard();
  var [mode, setMode] = useState('tree');
  var [clickedPath, setClickedPath] = useState(null);

  var onCreateMenu = function onCreateMenu(items, node) {
    var {
      path
    } = node;

    if (path) {
      items.push({
        text: 'Copy _path',
        // the text for the menu item
        title: 'Show the _path for this node',
        // the HTML title attribute
        className: 'example-class',
        // the css class name(s) for the menu item
        click: () => pathTojq(path, copyToClipboard) // the function to call when the menu item is clicked

      });
    }

    items.forEach(function (item, index, items) {
      if ('submenu' in item) {
        items[index].className += ' submenu-highlight';
      } else {
        items[index].className += ' rainbow';
      }
    });
    items = items.filter(function (item) {
      return item.type !== 'separator';
    });
    return items;
  };

  useEffect(() => {
    // setText(JSON.stringify(data));
    setJson(data); // if (_.size(text) > 1000000) {
    //   setMode('preview');
    // } else {
    //   setMode('tree');
    // }
  }, [data]);
  var jsonEditorOptions = {
    id: 'console-output-json-editor',
    json,
    mode,
    modes: false,
    indentation: 1,
    statusBar: true,
    expandAll: true,
    onChangeJSON: json => {
      setJson(json);
    },
    // onChangeText: (jsonString) => {
    //   setText(jsonString);
    // },
    onEvent: (node, event) => _onEvent(node, event, copyToClipboard),
    onCreateMenu,
    onModeChange: setMode
  };
  var contentOptions = {
    loading,
    data,
    json,
    clickedPath,
    jsonEditorOptions,
    mode,
    setMode
  };
  var content = generateContent(contentOptions);
  return /*#__PURE__*/React.createElement(React.Fragment, null, content, /*#__PURE__*/React.createElement(Drawer, {
    title: "Output",
    placement: "right",
    closable: true,
    onClose: closeDrawer,
    visible: drawerVisible,
    width: screenWidth,
    forceRender: true,
    bodyStyle: {
      padding: '0px'
    }
  }, content));
}